import { render } from "./NavbarWeekly.vue?vue&type=template&id=257dc3fe&scoped=true"
import script from "./NavbarWeekly.vue?vue&type=script&lang=js"
export * from "./NavbarWeekly.vue?vue&type=script&lang=js"

import "./NavbarWeekly.vue?vue&type=style&index=0&id=257dc3fe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-257dc3fe"]])

export default __exports__